export default "__VITE_ASSET__D1D35_sK__"